export default __webpack_public_path__ + "static/media/slider1.2a5aaaa7.png";